import * as React from 'react';

import { theme } from '@notino/react-styleguide';
import { VoucherIconVariantFeatureFlag } from '@notino/shared/definitions/types';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { useVoucherDiscountContext } from './context';
import { TextIcon } from './styled';

export const usePercentageIconAbcTest = (percentage: number) => {
  const { experiment_pd_voucher_icon_variant } = useFeatureFlags();
  const { hasContrastBg, hasBlackFridayDiscount } = useVoucherDiscountContext();

  const iconBgColor =
    hasBlackFridayDiscount || hasContrastBg
      ? theme.color.background.inverse
      : theme.color.background.highlight;

  switch (experiment_pd_voucher_icon_variant) {
    case VoucherIconVariantFeatureFlag.NoIcon:
      return undefined;

    case VoucherIconVariantFeatureFlag.TextIcon:
      return <TextIcon bgColor={iconBgColor}>Top!</TextIcon>;

    case VoucherIconVariantFeatureFlag.Default:
    default:
      return percentage;
  }
};
